<template>
  <div class="wrapper store-coop-list">
    <admin-title :title="$route.meta.name" />

    <div class="header-search">
      <el-form ref="searchForm" inline :model="searchData" label-width="">
        <el-form-item label="门店名称">
          <el-input
            v-model.trim="searchData.storeName"
            size="small"
            placeholder="请输入门店名称"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="审核时间">
          <el-date-picker
            v-model="searchData.timeRange"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="withdraw-audit-time-range"
          />
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">
            查询
          </el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-divider /> -->

    <div class="tabs-toolbar">
      <el-tabs v-model="activeTab" class="status-tabs" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all" />
        <el-tab-pane label="审核中" name="1" />
        <el-tab-pane label="审核通过" name="2" />
        <el-tab-pane label="审核拒绝" name="3" />
      </el-tabs>
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.store_cooperation_withdraw_audit_export)"
        type="primary"
        size="small"
        icon="el-icon-download"
        class="export-btn"
        @click="exportExcel"
      >
        导出
      </el-button>
    </div>

    <tp-table
      :isNeedSerialNumber="true"
      :isCheckBox="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
    />

    <WithdrawAuditDialog
      :visible.sync="auditDialog.visible"
      :row="auditDialog.row"
      @success="getList"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import WithdrawAuditDialog from "./components/withdraw-audit-dialog.vue";
import {
  getWithdrawalAuditPageAPI,
  exportWithdrawalAuditAPI,
} from "./api";

/** 审核中 */
const STATUS_PENDING = 1;
/** 审核通过 */
const STATUS_PASS = 2;
/** 审核拒绝 */
const STATUS_REJECT = 3;

const statusTagMap = {
  [STATUS_PENDING]: { text: "审核中", type: "warning" },
  [STATUS_PASS]: { text: "审核通过", type: "success" },
  [STATUS_REJECT]: { text: "审核拒绝", type: "danger" },
};

function coopJLine(h, label, val) {
  const text = val != null && val !== "" ? val : "-";
  return (
    <div class="j-line">
      <span class="lbl">{label}：</span>
      <span class="val">{text}</span>
    </div>
  );
}

const columns = [
  {
    label: "申请时间",
    prop: "applyTime",
    minWidth: "170",
    customRender(h, row) {
      return <p class="joint-plain">{row.applyTime || "-"}</p>;
    },
  },
  {
    label: "提现金额",
    prop: "amount",
    minWidth: "100",
    customRender(h, row) {
      const v = row.amount;
      return <p class="joint-plain">{v != null && v !== "" ? v : "-"}</p>;
    },
  },
  {
    label: "门店信息",
    prop: "storeInfo",
    minWidth: "260",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "门店名称", row.storeName)}
          {coopJLine(h, "门店地址", row.storeAddress || row.address)}
          {coopJLine(h, "区域负责人", row.areaFollowUserName)}
        </div>
      );
    },
  },
  {
    label: "提现状态",
    prop: "status",
    minWidth: "110",
    customRender(h, row) {
      const s = row.status != null ? Number(row.status) : null;
      const cfg = s != null ? statusTagMap[s] : null;
      if (!cfg) {
        return <p class="joint-plain">-</p>;
      }
      return (
        <el-tag size="small" type={cfg.type}>
          {row.statusName || cfg.text}
        </el-tag>
      );
    },
  },
  {
    label: "商家转账信息",
    prop: "payeeInfo",
    minWidth: "260",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "收款人", row.payeeIdName)}
          {coopJLine(h, "收款账号", row.payeeAlipayAccount)}
        </div>
      );
    },
  },
  {
    label: "审核时间",
    prop: "reviewTime",
    minWidth: "170",
    customRender(h, row) {
      return <p class="joint-plain">{row.reviewTime || "-"}</p>;
    },
  },
  {
    label: "审核备注",
    prop: "reviewRemark",
    minWidth: "120",
    customRender(h, row) {
      return <p class="joint-plain">{row.reviewRemark || "-"}</p>;
    },
  },
  {
    label: "操作",
    width: "110",
    fixed: "right",
    customRender(h, row) {
      const pending = Number(row.status) === STATUS_PENDING;
      const canAudit = this.isShowBtn(this.AUTH_BTN.store_cooperation_withdraw_audit_do);
      if (!pending || !canAudit) {
        return <span>-</span>;
      }
      return (
        <el-link
          underline={false}
          type="primary"
          onClick={() => this.openAuditDialog(row)}
        >
          提现审核
        </el-link>
      );
    },
  },
];

export default {
  name: "WithdrawalAuditList",
  mixins: [authBtnMixin],
  components: {
    WithdrawAuditDialog,
  },
  data() {
    return {
      columns,
      activeTab: "all",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        storeName: "",
        timeRange: null,
      },
      auditDialog: {
        visible: false,
        row: {},
      },
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    /** 切换状态 Tab 后刷新列表 */
    handleTabClick() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getList();
      }
    },
    /** 组装列表与导出共用查询参数 */
    buildQueryParams() {
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        storeName: this.searchData.storeName || undefined,
      };
      if (this.activeTab !== "all") {
        params.status = Number(this.activeTab);
      }
      const range = this.searchData.timeRange;
      if (range && range.length === 2) {
        params.leftReviewDate = range[0];
        params.rightReviewDate = range[1];
      }
      return params;
    },
    /** 点击查询，从第一页开始拉取 */
    handleQuery() {
      this.currentPage = 1;
      this.getList();
    },
    /** 重置筛选项并刷新列表 */
    reset() {
      this.searchData = {
        storeName: "",
        timeRange: null,
      };
      this.activeTab = "all";
      this.currentPage = 1;
      this.getList();
    },
    /** 拉取提现审核分页数据 */
    async getList() {
      const res = await getWithdrawalAuditPageAPI(this.buildQueryParams());
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    /** 导出当前筛选结果 */
    exportExcel() {
      const data = { ...this.buildQueryParams() };
      delete data.page;
      delete data.pageSize;
      exportWithdrawalAuditAPI(data);
    },
    /** 打开提现审核弹窗 */
    openAuditDialog(row) {
      this.auditDialog.row = { ...row };
      this.auditDialog.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-toolbar {
  position: relative;
  margin-bottom: 16px;
}

.status-tabs {
  width: 100%;

  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

.export-btn {
  position: absolute;
  right: 0;
  top: 0;
}

.withdraw-audit-time-range {
  width: 360px;
}
</style>

<style lang="scss">
@import "../coop-list-table-cells.scss";
</style>
